import { LOGIN_METRICS } from "@/entry/constants";
import * as MetricsUtils from "@/entry/utils/metrics-utils";
import { LOGIN_JOURNEY, LOGIN_STAGES, LOGIN_STAGE_RESULTS, StructuredLog, trackClientLoginStage } from "@agentx/agentx-services";
import { hashString } from "../utils/hashUtils";
import { buildStateParam } from "./utils";
const { submitPreLoginEventBeforeRedirect } = MetricsUtils;
export async function redirectToLoginWithEmailHash(email) {
    const currentUrl = new URL(window.location.href);
    const emailHash = await hashString(email);
    const state = buildStateParam(emailHash);
    currentUrl.searchParams.set("state", state);
    // This is a workaround for an issue in the webex-js-sdk: https://sqbu-github.cisco.com/CBABU/wxcc-desktop/pull/6470#discussion_r2626506
    currentUrl.searchParams.set("code", "unused");
    trackClientLoginStage({
        stage: LOGIN_STAGES.IDBROKER,
        result: LOGIN_STAGE_RESULTS.STARTED,
        endpoint: LOGIN_JOURNEY.ENDPOINTS.LOGIN_PAGE_EMAIL_SUBMIT
    });
    // Wait up to PRE_LOGIN_METRICS_TIMEOUT_MS for metrics before redirecting.
    // TSA XHR can hang indefinitely in CI/automation; the timeout ensures login is never blocked.
    await submitPreLoginEventBeforeRedirect(LOGIN_METRICS.REDIRECT_WITH_STATE, { state }, emailHash);
    StructuredLog.debug("Login/Redirect/WithEMailState", "", { url: currentUrl.toString() });
    window.location.replace(currentUrl.toString());
}
